module.exports = __webpack_public_path__ + "img/1024.2aeb63d9.svg";